/**
 * Converts an attribute to a boolean
 */
function attrToBool(attr) {
  if (typeof attr === "boolean") {
    return attr;
  }

  if (typeof attr === "string") {
    return attr === "true" || attr === "";
  }

  return !!attr;
}
/**
 * Converts an attribute to a number
 */

function attrToNumber(attr) {
  return Number(attr);
}
/**
 * Creates a short content-based hash
 */

function hash(value) {
  let hash = 0;

  for (let i = 0; i < value.length; i++) {
    let char = value.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash |= 0;
  }

  return Math.abs(hash);
}
/**
 * Flattens a list of options. Used option groups need to be
 * flattened into an array for easy parsing
 */

function flattenOptions(options) {
  return options.flatMap(
    (
      o // @ts-ignore
    ) => (Array.isArray(o.options) ? o.options : o)
  );
}
/**
 * Builds an asset URL using environment context.
 */

function getAssetsUrl(fileName) {
  if (/^data:image/.test(fileName)) return fileName; // "https://ui.trailhead.com/components/v4.29.3" is replaced at build time
  // based on the build target (import.meta.url for web
  // builds and the CDN url for npm builds)
  // https://github.com/facebook/jest/issues/11634

  const base = "https://ui.trailhead.com/components/v4.29.3".replace(
    /\/modules.*/,
    ""
  );
  return [base, fileName].map((p) => p.replace(/^\/|\/$/, "")).join("/");
}
/**
 * Fetches a remote asset.
 */

async function fetchAsset(url) {
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(async (r) => {
        const text = await r.text();
        if (!r.ok) reject(text);
        resolve(text);
      })
      .catch((e) => reject(e));
  });
}
/**
 * Expands LWC's proxy objects to JSON for easier viewing
 */

function getProxyValue(proxy) {
  return JSON.parse(JSON.stringify(proxy));
}
/**
 * Waits until an element exists
 */

async function exists(selector, node, options) {
  const timeout = options?.timeout ?? Infinity;
  const interval = 30;
  let timer = 0;
  let intervalId;
  return new Promise((resolve) => {
    intervalId = setInterval(() => {
      try {
        const el = node.querySelector(selector);

        if (el) {
          clearInterval(intervalId);
          return resolve(el);
        } else {
          timer += interval;

          if (timer >= timeout) {
            return resolve(null);
          }
        }
      } catch (error) {
        clearInterval(intervalId);
      }
    }, interval);
  });
}

export {
  attrToBool,
  attrToNumber,
  exists,
  fetchAsset,
  flattenOptions,
  getAssetsUrl,
  getProxyValue,
  hash,
};
